@for (warning of warnings; track warning) {
  <div>
    @if (showWarning) {
      <div class="warning-box mod-orange text-left flex-center-vertical flex-row justify-center">
        <span class="bpi__icon-info warning-icon"></span>
        <div class="font-normal font-size-13">
          {{ warning.message | translate }}
          <a [href]="warning?.link ?? getHelpdeskUrl(warning)" target="_blank" class="font-medium">
            {{ warning.link_message | translate }}
          </a>
        </div>
      </div>
    }
  </div>
}
<bp-switch [model]="slider" field="documents" [mb]="20" (valueChange)="onSliderChange()" [disabled]="disabled">
  <div left class="text-small-black">
    {{ "checkout_securities_toggle_documents_1" | translate: [getTradeType() | translate] }}
    <a [href]="getUrl()" [target]="'_blank'">{{ "checkout_securities_toggle_documents_2" | translate }}</a>
    {{ "checkout_securities_toggle_documents_3" | translate }}
    <a [href]="getUrl()" [target]="'_blank'">{{ "checkout_securities_toggle_documents_4" | translate }}</a
      >, <a [href]="getUrl()" [target]="'_blank'">{{ "checkout_securities_toggle_documents_5" | translate }}</a
      >,
      <a [href]="getUrl()" [target]="'_blank'">{{ "checkout_securities_toggle_documents_6" | translate }}</a>
      {{ "checkout_securities_toggle_documents_7" | translate }}
      <a [href]="getUrl()" [target]="'_blank'">{{ "checkout_securities_toggle_documents_8" | translate }}</a>
      {{ "checkout_securities_toggle_documents_9" | translate }}
    </div>
  </bp-switch>
  <!-- Toggle for user Appropriateness Test -->
  @if (showRiskToggle) {
    <bp-switch
      [model]="slider"
      field="investRisk"
      [mb]="20"
      (valueChange)="onSliderChange()"
      [disabled]="disabled"
      >
      <div left>
        <div class="font-size-13 large-weight pb-10">
          {{ "stocks_toggle_not_appropriate_title" | translate }}
        </div>
        <div class="font-size-11 info-color">
          {{ "stocks_toggle_not_appropriate_description" | translate }}
        </div>
      </div>
    </bp-switch>
  }
